import Container from "layouts/container/Container";

import { useContext } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Notice from "./Notice";

function Article(props) {
    const { type } = props;
    const { isMobile } = useContext(BrowserDetectContext);
    return (
        <Container padding={!isMobile && "60px 0 "}>
            <Container minWidth={!isMobile &&1300} maxWidth={1300}>
                {
                    {
                        notice: <Notice type={type} />,

                    }[type]

                }
            </Container>
        </Container>
    );
}

export default Article;